export const CompoundUnits = [
  { label: "Kcal/Kg", value: "Kcal/Kg" },
  { label: "Kcal/M3", value: "Kcal/M3" },
];

export enum UNITS_ENUM {
  KCAL_KG = "Kcal/Kg",
  KCAL_M3 = "Kcal/M3",
}

export enum TempKeyUnit {
  "Kcal/Kg" = "kcalKg",
  "Kcal/M3" = "kcalM3",
}

export const InputByFixed = [
  { label: "PI", value: "PI" },
  { label: "Manual", value: "Manual" },
];

export enum EmissionObjectEnum {
  TVOC = "tvoc",
  BZ = "bz",
  BD = "bd",
  VCM = "vcm",
  EDC = "edc",
}

export const EmissionObject = [
  { value: "tvoc", label: "TVOCs" },
  { value: "bz", label: "BZ" },
  { value: "bd", label: "BD" },
  { value: "vcm", label: "VCM" },
  { value: "edc", label: "EDC" },
];

export const MapEmissionObject = {
  tvoc: "TVOCs",
  bz: "BZ",
  bd: "BD",
  vcm: "VCM",
  edc: "EDC",
};
export type EmissionKeys = keyof typeof MapEmissionObject;

export const EmissionObjectWithAll = [
  { value: "tvoc,bz,bd,vcm,edc", label: "All" },
  { value: "tvoc", label: "TVOCs" },
  { value: "bz", label: "BZ" },
  { value: "bd", label: "BD" },
  { value: "vcm", label: "VCM" },
  { value: "edc", label: "EDC" },
];

export enum InputByFixedEnum {
  PI = "PI",
  MANUAL = "MANUAL",
}

export const CalculationMethodFixed = [{ label: "Emission Factor", value: "Emission Factor" }];

export const FormatCalendarPicker = "YYYY-MM-DD HH:mm";
export const FormatDateCalendarPicker = "YYYY-MM-DD";

export const EmptyString = "empty_string";

export const MonthsDisplay = [
  { title: "Jan", dataIndex: "jan" },
  { title: "Feb", dataIndex: "feb" },
  { title: "Mar", dataIndex: "mar" },
  { title: "Apr", dataIndex: "apr" },
  { title: "May", dataIndex: "may" },
  { title: "Jun", dataIndex: "jun" },
  { title: "Jul", dataIndex: "jul" },
  { title: "Aug", dataIndex: "aug" },
  { title: "Sep", dataIndex: "sep" },
  { title: "Oct", dataIndex: "oct" },
  { title: "Nov", dataIndex: "nov" },
  { title: "Dec", dataIndex: "dec" },
  { title: "Total", dataIndex: "total" },
];

export const MonthsDisplayNoTotal = [
  { title: "Jan", dataIndex: "jan" },
  { title: "Feb", dataIndex: "feb" },
  { title: "Mar", dataIndex: "mar" },
  { title: "Apr", dataIndex: "apr" },
  { title: "May", dataIndex: "may" },
  { title: "Jun", dataIndex: "jun" },
  { title: "Jul", dataIndex: "jul" },
  { title: "Aug", dataIndex: "aug" },
  { title: "Sep", dataIndex: "sep" },
  { title: "Oct", dataIndex: "oct" },
  { title: "Nov", dataIndex: "nov" },
  { title: "Dec", dataIndex: "dec" },
];

export const MonthsDisplayPascal = [
  { title: "January", dataIndex: "jan" },
  { title: "February", dataIndex: "feb" },
  { title: "March", dataIndex: "mar" },
  { title: "April", dataIndex: "apr" },
  { title: "May", dataIndex: "may" },
  { title: "June", dataIndex: "jun" },
  { title: "July", dataIndex: "jul" },
  { title: "August", dataIndex: "aug" },
  { title: "September", dataIndex: "sep" },
  { title: "October", dataIndex: "oct" },
  { title: "November", dataIndex: "nov" },
  { title: "December", dataIndex: "dec" },
];

export enum UnitAllEnum {
  TON = "Ton",
  KG = "Kg",
  L = "L",
  M3 = "M3",
  KG_L = "Kg/L",
  SG = "SG",
  KG_M3 = "Kg/m3",
  HR = "Hr",
  G = "g",
  MG = "Mg",
}
